import { useCallback, useRef } from 'react';
import { useMemoizedFn, useUnmount } from 'ahooks';

interface Props {
  timeoutMs: number;
  onCheckTimeout: VoidFunc;
}

/** 检测ping超时逻辑 */
export const useCheckPingTimeout = (params: Props) => {
  const { timeoutMs, onCheckTimeout } = params || {};
  const timeoutCallback = useMemoizedFn(onCheckTimeout);

  const timerRef = useRef(null);

  const clear = useCallback(() => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }
  }, []);

  const onceCheckPass = useCallback(() => {
    clear();

    timerRef.current = setTimeout(timeoutCallback, timeoutMs);
  }, [clear, timeoutCallback, timeoutMs]);

  useUnmount(() => {
    clear();
  });

  return {
    onceCheckPass,
    clear,
  };
};
